import React, { useState, useEffect } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { toast } from 'react-toastify';
import Cookies from 'js-cookie'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
// import { adminMainUrl } from '../../../Config';
// import { adminLoginSchema } from '../../../ValidationScema';
import 'react-toastify/dist/ReactToastify.css';
// import Api from '../../../Api';
// import { getRoleList, getRoleView } from '../../../Redux/action/Admin/RolePermissionAction';
import { useDispatch, useSelector } from 'react-redux';
import { getRoleView } from '../../Redux/action/Admin/RolePermissionAction';
import { adminLoginSchema } from '../../ValidationScema';
import { adminMainUrl } from '../../Config';
import axios from 'axios';

const CustomerLogin = ({ loadingCompanyDetail, CompanyDetailData }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [showPassword, setShowPassword] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [roleId, setRoleId] = useState([]);


    const initialValues = {
        username: "",
        password: "",
    };

    const burl = new URLSearchParams(window.location.search).get('burl');
    const customertoken = Cookies.get("customertoken");
    useEffect(() => {
        if (customertoken) {
            navigate('/customer-dashboard/profile');
        }
    }, [customertoken]);
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object({
            username: Yup.string()
                .required("Please enter your username."),
            password: Yup.string()
                .required("Please enter your password.")
                .min(4, "Password must be at least 4 character"),
        }),
        onSubmit: async (values) => {
            setIsSubmitting(true);
            try {
                axios.post(`${adminMainUrl}/api/customer-login`, values, {
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                }).then((response) => {
                    if (response.status === 200) {
                        const data = response.data;
                        Cookies.set("customertoken", data.authToken);
                        // Check if the token was successfully set
                        if (Cookies.get("customertoken")) {
                            toast.success(data?.msg);
                            setIsSubmitting(false);
                            // sessionStorage.setItem('userData', JSON.stringify(data));
                            if (burl) {
                                navigate(`/${burl}`);
                            } else {
                                if (response.data.profileCompleted) {
                                    navigate('/customer-dashboard/dashboard');
                                } else {
                                    navigate('/customer-dashboard/profile');
                                }
                            }
                            formik.resetForm();
                        } else {
                            toast.error("Failed to set token. Redirecting to login.");
                            setIsSubmitting(false);
                            navigate('/customer/login');
                        }
                    } else {
                        toast.error(response?.data?.msg);
                        setIsSubmitting(false);
                        // handle login failure
                    }
                }).catch((error) => {
                    console.error("Login error:", error);
                    let err_msg = "An error occurred during login. Please try again.";
                    if(error && error.response && error.response.data && error.response.data.msg){
                        err_msg = error.response.data.msg;
                    }
                    toast.error(err_msg);
                    setIsSubmitting(false);
                });
            } catch (error) {
                console.error("Login error:", error);
                setIsSubmitting(false);
                toast.error("An error occurred. Please try again.");
            }
        },
    });

    return (
        <>
            <div className="account-page">
                <div className="main-wrapper">
                    <div className="account-content">
                        <div className="d-flex flex-wrap w-100 vh-100 overflow-hidden account-bg-01">
                            <div className="d-flex align-items-center justify-content-center flex-wrap vh-100 overflow-auto p-4 w-50 bg-backdrop">
                                {/* <form action="index.html" className="flex-fill"> */}
                                <form className="flex-fill" onSubmit={formik.handleSubmit}>
                                    {/* <form className="" > */}
                                    <div className="mx-auto mw-450">
                                        <div className="text-center mb-4">
                                            {/* <img
                                                src="/assets/img/logo.png"
                                                className="img-fluid"
                                                alt="Logo"
                                            /> */}

                                            <img
                                                src={CompanyDetailData ? CompanyDetailData.logo_path : "/assets/img/logo.png"}
                                                className="img-fluid company-logo-flexichain-login"
                                                alt="Logo"
                                                onError={({ currentTarget }) => {
                                                    currentTarget.onerror = null;
                                                    currentTarget.src = "/assets/img/logo.png";
                                                }}
                                            />

                                            <h3>Customer Login</h3>
                                        </div>

                                        <div className="mb-3">
                                            <label className="col-form-label">Username</label>
                                            <div className="position-relative">
                                                <span className="input-icon-addon">
                                                    <i className="ti ti-user" />
                                                </span>
                                                <input
                                                    type="username"
                                                    id="username"
                                                    className="form-control"
                                                    placeholder="Enter username"
                                                    name="username"
                                                    value={formik.values.username}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    style={{
                                                        background: "#fff",
                                                        border: formik.errors.username && formik.touched.username ? "1px solid red" : "",
                                                    }}
                                                />
                                            </div>
                                            {formik.errors.username && formik.touched.username && (
                                                <div className="text-red-500 text-base">{formik.errors.username}</div>
                                            )}
                                        </div>
                                        <div className="mb-3">
                                            <label className="col-form-label">Password</label>
                                            <div className="pass-group">
                                                <input
                                                    placeholder='Enter Your Password'
                                                    type={showPassword ? "password" : "text"}
                                                    id="password"
                                                    className="pass-input form-control"
                                                    name="password"
                                                    value={formik.values.password}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    style={{
                                                        background: "#fff",
                                                        border: formik.errors.password && formik.touched.password ? "1px solid red" : "",
                                                    }}
                                                />
                                                {
                                                    showPassword ?
                                                        <VisibilityOffIcon className='cursor-pointer toggle-password' style={{ fill: "rgb(82 80 80)" }} onClick={() => { setShowPassword(!showPassword) }} />
                                                        :
                                                        <VisibilityIcon className='cursor-pointer toggle-password' style={{ fill: "rgb(82 80 80)" }} onClick={() => { setShowPassword(!showPassword) }} />
                                                }
                                                {/* <span className="ti toggle-password ti-eye-off" /> */}
                                            </div>
                                            {formik.errors.password && formik.touched.password && (
                                                <div className="text-red-500 text-base">{formik.errors.password}</div>
                                            )}
                                        </div>
                                        {/* <div className="d-flex align-items-center justify-content-between mb-3">
                                            <div className="form-check form-check-md d-flex align-items-center">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    defaultValue=""
                                                    id="checkebox-md"
                                                    defaultChecked=""
                                                />
                                                <label className="form-check-label" htmlFor="checkebox-md">
                                                    Remember Me
                                                </label>
                                            </div>
                                            <div className="text-end">
                                                <Link to="/forget-email"
                                                    className="text-primary fw-medium link-hover">
                                                    Forgot Password?
                                                </Link>
                                            </div>
                                        </div> */}
                                        <div className="mb-3">
                                            <button className="btn btn-primary w-100 " type="submit" disabled={isSubmitting}>
                                                {isSubmitting ? <i className="fa fa-spinner fa-spin" /> : "Login"}
                                            </button>
                                            {/* <button type="submit" className="btn btn-primary w-100">
                                                Sign In
                                            </button> */}
                                        </div>
                                        {/* <div className="mb-3">
                                            <h6>
                                                New on our platform?
                                                <a href="register.html" className="text-purple link-hover">
                                                    {" "}
                                                    Create an account
                                                </a>
                                            </h6>
                                        </div> */}
                                        {/* <div className="form-set-login or-text mb-3">
                                            <h4>OR</h4>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-center flex-wrap mb-3">
                                            <div className="text-center me-2 flex-fill">
                                                <a
                                                    href="javascript:void(0);"
                                                    className="br-10 p-2 px-4 btn bg-pending  d-flex align-items-center justify-content-center"
                                                >
                                                    <img
                                                        className="img-fluid m-1"
                                                        src="assets/img/icons/facebook-logo.svg"
                                                        alt="Facebook"
                                                    />
                                                </a>
                                            </div>
                                            <div className="text-center me-2 flex-fill">
                                                <a
                                                    href="javascript:void(0);"
                                                    className="br-10 p-2 px-4 btn bg-white d-flex align-items-center justify-content-center"
                                                >
                                                    <img
                                                        className="img-fluid  m-1"
                                                        src="assets/img/icons/google-logo.svg"
                                                        alt="Facebook"
                                                    />
                                                </a>
                                            </div>
                                            <div className="text-center flex-fill">
                                                <a
                                                    href="javascript:void(0);"
                                                    className="bg-dark br-10 p-2 px-4 btn btn-dark d-flex align-items-center justify-content-center"
                                                >
                                                    <img
                                                        className="img-fluid  m-1"
                                                        src="assets/img/icons/apple-logo.svg"
                                                        alt="Apple"
                                                    />
                                                </a>
                                            </div>
                                        </div> */}
                                        <div className="text-center">
                                            <p className="fw-medium text-gray">Copyright © 2024 - Flexichain</p>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CustomerLogin